import { TMargin, TWidget } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import { TSeparatorData } from '../../types/data';
import { TSeparatorOption } from '../../types/options';
import { TSeparatorHierarchy, TSeparatorVariant } from '../../types/styles';
import { capitalText, getInlineStyles } from '../../utils/styles';
import { TextCommon } from '../UI/Text/TextCommon';
import styles from './separator.module.css';

type TSeparatorProps<TD, TO> =
    | {
          isWidget: false;
          text?: string;
          metaText?: string;
          separatorVariant?: TSeparatorVariant;
          separatorHierarchy?: TSeparatorHierarchy;
          margin?: TMargin;
      }
    | {
          isWidget: true;
          widget: TWidget<TD, TO>;
      };

export function Separator(props: TSeparatorProps<TSeparatorData, TSeparatorOption>) {
    const { isWidget } = props;
    const variant = isWidget ? props.widget?.options?.separatorVariant : props.separatorVariant;
    const separatorHierarchy = isWidget ? props.widget?.options?.separatorHierarchy : props.separatorHierarchy;
    const metaText = isWidget ? props.widget?.data?.metaText : props.metaText;

    return (
        <div
            data-test={isWidget ? props.widget?.uid : ''}
            className={clsx(
                styles.separatorBlock,
                styles[`separatorVariant${capitalText(variant ?? 'line')}`],
                styles[`separatorHierarchy${capitalText(separatorHierarchy)}`],
            )}
            style={getInlineStyles({ margin: isWidget ? props.widget?.options?.margin : props.margin })}
        >
            {variant === 'subheader' ? (
                <>
                    <TextCommon
                        isWidget={false}
                        content={isWidget ? props.widget?.data?.text : props.text}
                        options={{ variant: 'subheader', textColor: 'grey_72_lc' }}
                    />
                    {metaText && <TextCommon isWidget={false} content={metaText} options={{ variant: 'subheader', textColor: 'grey_72_lc' }} />}
                </>
            ) : null}
        </div>
    );
}
